import { Button } from "antd";
import PackageDescription from "./SinglePackageDescription";
import { pushBeginCheckout } from "../../../utils/gtm";

const SinglePackageCard = ({
  packageInfo,
  packageType,
  setBundle,
  setCurrent,
  eventInfo,
  firstDayDate,
  secondDayDate,
}: any) => {
  return (
    <div className="relative h-[510px] md:h-[380px] lg:h-[470px] xl:h-[500px] 2xl:h-[560px]  bg-registration-blue border-2 border-custom-pink-900 rounded-[10px] px-4 xl:px-6 pb-10 mb-10 sm:mb-0">
      <div>
        <div className="w-[120px] md:w-[90px] xl:w-[100px] flex items-center justify-center m-auto h-8 -mt-4 bg-custom-pink-900 text-white rounded-[50px] border text-xl md:text-sm xl:text-base font-bold font-saira">
          PAKET {packageType}
        </div>

        <div className="text-white text-base md:text-[10px] md:leading-3 lg:text-xs xl:text-base 2xl:text-base  font-bold font-lato mt-8 h-auto md:h-10 xl:h-20">
          {packageType !== "D"
            ? "ULAZ NA KONFERENCIJU + PRISTUP CYBERSEC EXPO ZONI"
            : "ULAZNICA NA KONFERENCIJU ZA STUDENTE"}
        </div>
      </div>

      {eventInfo && (
        <div className="mt-4 mb-8 md:mb-4 lg:mb-8 flex justify-center items-center">
          <div className="flex flex-col gap-2 md:gap-0 lg:gap-2 ">
            <div className="flex items-center justify-between gap-2">
              {eventInfo?.priceType !== "regular" ? (
                <>
                  <div className="relative text-base sm:text-[9px] lg:text-xs xl:text-sm 2xl:text-lg font-bold text-white xl:mb-1">
                    {packageInfo?.price} KM
                    <div className="absolute -left-1 bottom-[35%] border border-white w-[120%] -rotate-[25deg]"></div>
                  </div>
                  <div className="text-3xl sm:text-base lg:text-[22px] xl:text-[28px] 2xl:text-3xl font-black text-white xl:mb-1">
                    {packageInfo?.earlyPrice} KM
                  </div>
                </>
              ) : (
                <div className="text-3xl sm:text-base lg:text-[22px] xl:text-[28px] 2xl:text-3xl font-black text-white xl:mb-1">
                  {packageInfo?.price} KM
                </div>
              )}
            </div>
            <div className="flex items-center justify-between gap-2">
              {eventInfo?.priceType !== "regular" ? (
                <>
                  <div className="relative text-base sm:text-[9px] lg:text-xs xl:text-sm 2xl:text-lg font-bold text-custom-pink-900">
                    {(packageInfo?.price / 1.96).toFixed(0)} EUR
                    <div className="absolute -left-1 bottom-[35%] border border-custom-pink-900 w-[120%] -rotate-[25deg]"></div>
                  </div>
                  <div className="text-3xl sm:text-base lg:text-[22px] xl:text-[28px] 2xl:text-3xl font-black text-custom-pink-900">
                    {(packageInfo?.earlyPrice / 1.96).toFixed(0)} EUR
                  </div>
                </>
              ) : (
                <div className="text-3xl sm:text-base lg:text-[22px] xl:text-[28px] 2xl:text-3xl font-black text-custom-pink-900">
                  {(packageInfo?.price / 1.96).toFixed(0)} EUR
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <PackageDescription
        packageType={packageInfo?.package}
        firstDayDate={firstDayDate}
        secondDayDate={secondDayDate}
      />

      <div className="absolute bottom-6 left-0 w-full">
        <Button
          disabled={!packageInfo}
          onClick={() => {
            const unitPrice =
              eventInfo?.priceType !== "regular"
                ? Number(packageInfo?.earlyPrice)
                : Number(packageInfo?.price);
            const vat = eventInfo?.vat ? 1.17 : 1;
            pushBeginCheckout(packageInfo?.package, unitPrice, Math.round(unitPrice * vat * 100) / 100);
            setBundle(packageInfo);
            setCurrent(1);
          }}
          className="font-bold text-white text-base md:text-xs lg:text-sm 2xl:text-[16px] h-8 px-6 md:px-2 lg:px-4 2xl:px-5 font-saira  bg-custom-pink-900 mt-4 border-2 border-white rounded-[5px] shadow"
        >
          ODABERI
        </Button>
      </div>
    </div>
  );
};

export default SinglePackageCard;
